/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React, { useMemo, useState } from 'react';
import { unstable } from '@broadleaf/admin-components';

import { TaxAlertRibbon } from 'app/common/components';

import { mergeDefaultAndCustomComponents } from './components';
import { PayPalViewProps } from './constants';
import { usePayPalState, useContextParams } from './hooks';

const { MetadataUtils } = unstable;
const { getEndpointByType } = MetadataUtils;

const PayPalView = props => {
  const [dismissed, setDismissed] = useState(false);

  return (
    <>
      <TaxAlertRibbon
        metadata={props.metadata}
        dismissed={dismissed}
        setDismissed={setDismissed}
      />
      <MountPayPalView {...props} dismissed={dismissed} />
    </>
  );
};

PayPalView.propTypes = PayPalViewProps;

const MountPayPalView = ({
  className,
  components: componentsProp,
  initialState,
  metadata,
  reducer,
  dismissed
}) => {
  const components = useMemo(
    () => mergeDefaultAndCustomComponents(componentsProp),
    [componentsProp]
  );
  const readConfig = useMemo(
    () => getEndpointByType(metadata, 'READ_PROPERTY'),
    [metadata]
  );
  const contextParams = useContextParams(metadata);
  const [state, dispatch] = usePayPalState({
    config: readConfig,
    context: contextParams,
    initialState,
    reducer
  });

  return (
    <components.Form
      className={className}
      components={components}
      dispatch={dispatch}
      metadata={metadata}
      state={state}
      dismissed={dismissed}
    />
  );
};

export default PayPalView;
export { PayPalView };
